var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import { createShorthandFactory, pxToRem, UIComponent, commonPropTypes, } from '../../lib';
import Layout from '../Layout/Layout';
/**
 * The Item Layout handles layout styles for menu items, list items and other similar item templates.
 */
var ItemLayout = /** @class */ (function (_super) {
    __extends(ItemLayout, _super);
    function ItemLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemLayout.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest, styles = _a.styles;
        var _b = this
            .props, as = _b.as, debug = _b.debug, endMedia = _b.endMedia, media = _b.media, renderMainArea = _b.renderMainArea, rootCSS = _b.rootCSS, mediaCSS = _b.mediaCSS, endMediaCSS = _b.endMediaCSS;
        var startArea = media;
        var mainArea = renderMainArea(this.props, this.state, classes);
        var endArea = endMedia;
        var mergedMediaClasses = cx('ui-item-layout__media', classes.media);
        var mergedEndMediaClasses = cx('ui-item-layout__endMedia', classes.endMedia);
        return (React.createElement(Layout, __assign({ as: as, className: classes.root, styles: styles.root, rootCSS: rootCSS, alignItems: "center", gap: pxToRem(8), debug: debug, reducing: true, start: startArea && (React.createElement("span", { style: mediaCSS, className: mergedMediaClasses }, startArea)), main: mainArea, end: endArea && (React.createElement("span", { style: endMediaCSS, className: mergedEndMediaClasses }, endArea)) }, rest)));
    };
    ItemLayout.displayName = 'ItemLayout';
    ItemLayout.className = 'ui-itemlayout';
    ItemLayout.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
        content: false,
    }), { contentMedia: PropTypes.any, content: PropTypes.any, debug: PropTypes.bool, header: PropTypes.any, endMedia: PropTypes.any, headerMedia: PropTypes.any, media: PropTypes.any, renderContentArea: PropTypes.func, renderHeaderArea: PropTypes.func, renderMainArea: PropTypes.func, rootCSS: PropTypes.object, mediaCSS: PropTypes.object, headerCSS: PropTypes.object, headerMediaCSS: PropTypes.object, contentCSS: PropTypes.object, contentMediaCSS: PropTypes.object, endMediaCSS: PropTypes.object, truncateContent: PropTypes.bool, truncateHeader: PropTypes.bool });
    ItemLayout.defaultProps = {
        as: 'div',
        renderMainArea: function (props, state, classes) {
            var renderHeaderArea = props.renderHeaderArea, renderContentArea = props.renderContentArea;
            var headerArea = renderHeaderArea(props, state, classes);
            var contentArea = renderContentArea(props, state, classes);
            return (React.createElement("div", { className: "ui-item-layout__main", style: {
                    gridTemplateRows: '1fr 1fr',
                } },
                headerArea,
                contentArea));
        },
        renderHeaderArea: function (props, state, classes) {
            var debug = props.debug, header = props.header, headerMedia = props.headerMedia, truncateHeader = props.truncateHeader, headerCSS = props.headerCSS, headerMediaCSS = props.headerMediaCSS;
            var mergedClasses = cx('ui-item-layout__header', classes.header);
            var mediaClasses = cx('ui-item-layout__headerMedia', classes.headerMedia);
            return !header && !headerMedia ? null : (React.createElement(Layout, { className: mergedClasses, alignItems: "end", gap: pxToRem(8), debug: debug, truncateMain: truncateHeader, main: header, rootCSS: headerCSS, end: headerMedia && (React.createElement("span", { style: headerMediaCSS, className: mediaClasses }, headerMedia)) }));
        },
        renderContentArea: function (props, state, classes) {
            var debug = props.debug, content = props.content, contentMedia = props.contentMedia, truncateContent = props.truncateContent, contentCSS = props.contentCSS, contentMediaCSS = props.contentMediaCSS;
            var mergedClasses = cx('ui-item-layout__content', classes.content);
            var mediaClasses = cx('ui-item-layout__contentMedia', classes.contentMedia);
            return !content && !contentMedia ? null : (React.createElement(Layout, { className: mergedClasses, alignItems: "start", gap: pxToRem(8), debug: debug, truncateMain: truncateContent, rootCSS: contentCSS, main: content, end: contentMedia && (React.createElement("span", { style: contentMediaCSS, className: mediaClasses }, contentMedia)) }));
        },
    };
    return ItemLayout;
}(UIComponent));
ItemLayout.create = createShorthandFactory(ItemLayout, 'content');
export default ItemLayout;
